module.exports = __webpack_public_path__ + "img/65_str.88ee2fa6.png";